import { Box, styled, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

// ── Outer modal shell — fixed, never scrolls ─────────────────────────────────
export const StyledBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 780,
  maxWidth: "calc(100vw - 32px)",
  maxHeight: "90vh",
  background: "#ffffff",
  borderRadius: "16px",
  outline: "none",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  boxShadow: "0 24px 60px rgba(11, 35, 115, 0.18)",
  [theme.breakpoints.down("md")]: { width: 540 },
  [theme.breakpoints.down("sm")]: { width: "calc(100vw - 32px)" },
}));

// ── Header bar ────────────────────────────────────────────────────────────────
export const ModalHeader = styled(Box)(() => ({
  background: "linear-gradient(135deg, #0B2373 0%, #0B65B5 100%)",
  padding: "18px 24px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexShrink: 0,
}));

export const ModalTitle = styled(Typography)(() => ({
  color: "#ffffff",
  fontSize: "18px",
  fontWeight: 700,
  letterSpacing: "0.01em",
}));

export const CloseBtn = styled(Box)(() => ({
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 32,
  height: 32,
  borderRadius: "50%",
  background: "#fff",
  transition: "background 0.2s",
  "&:hover": { background: "rgba(255,255,255,0.3)" },
}));

// ── Description strip ─────────────────────────────────────────────────────────
export const ModalDescription = styled(Typography)(({ theme }) => ({
  fontSize: "13px",
  color: "#5a6a85",
  textAlign: "center",
  padding: "14px 24px 0",
  lineHeight: 1.6,
  flexShrink: 0,
  [theme.breakpoints.down("sm")]: { fontSize: "11px" },
}));

// ── Scrollable image section ──────────────────────────────────────────────────
export const StyledBoxReview = styled(Box)(() => ({
  flex: 1,
  overflowY: "auto",
  padding: "16px 24px",
  "&::-webkit-scrollbar": { width: "5px" },
  "&::-webkit-scrollbar-track": { background: "#f0f4f8" },
  "&::-webkit-scrollbar-thumb": { background: "#a8c4e8", borderRadius: "4px" },
}));

// ── Image card ────────────────────────────────────────────────────────────────
export const StyledGrid = styled(Grid)(({ theme }) => ({
  border: "1px solid #d0e4f7",
  borderRadius: "10px",
  overflow: "hidden",
  background: "#f7fafd",
  transition: "box-shadow 0.2s, transform 0.2s",
  cursor: "pointer",
  "&:hover": {
    boxShadow: "0 4px 16px rgba(11,101,181,0.18)",
    transform: "translateY(-2px)",
  },
}));

export const StyledBoxImage = styled(Box)(() => ({
  width: "100%",
  height: "160px",
  overflow: "hidden",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "#eef4fb",
}));

export const StyedImg = styled("img")(() => ({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  display: "block",
  transition: "transform 0.3s ease",
  "&:hover": { transform: "scale(1.04)" },
}));

// ── Decline note field ────────────────────────────────────────────────────────
export const StyledDeclineNoteField = styled(Box)(() => ({
  padding: "0 24px 8px",
  flexShrink: 0,
}));

// ── Fixed footer with action buttons ─────────────────────────────────────────
export const ButtonWrapper = styled(Box)(() => ({
  display: "flex",
  justifyContent: "flex-end",
  gap: "12px",
  padding: "16px 24px",
  borderTop: "1px solid #e0eaf5",
  background: "#f7fafd",
  flexShrink: 0,
}));

// ── Full-screen image preview — handled via MUI Modal in component ───────────
